import React, { ReactElement } from 'react';

import HpmsCustomCardAPI from '@philips-emr/hpms-components/lib/components/hpms-custom-card/hpms-custom-card-api';
import { DeckAPI, DeckValue, FetchAPI, Image, Stamp, StampIcon, Token } from '@philips-emr/tws-components';
import { Color, Type } from '@philips-emr/tws-constants';
import Controller, { OnDynamicContentRender, OnMount, OnSelectItem, OnUnmount } from '@philips-emr/tws-core/lib/client';
import { MountEvent, RenderEvent, SelectItemEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService } from '@philips-emr/tws-core/lib/services';

import { MensagensAliases as Aliases, FragmentNames } from '../../codegen';
import { Endpoints } from '../../definitions/endpoints';
import { Routes } from '../../definitions/routes';
import { ToastService } from '../../services';
import FilterService from '../../services/filter-service';
import BaseController from '../base/base-controller';

import './mensagens.css';

enum StatusMensagem {
  YES = 'S',
  NO = 'N',
}

interface Mensagem {
  nrSequencia: string;
  dsTitulo: string;
  dsTexto: string;
  ieLeitura: StatusMensagem;
  ieTipoComunicado: string;
  iePrioridade: string;
  ieImportante: StatusMensagem;
  qtLeitura: number;
  dtLiberacao: string;
  ieAnexo: string;
  descricao: string;
  ieNaoLida: string;
  qtNaoLidas: string;
}

interface Anexo {
  dsFile: string;
  nrSequencia: number;
  nmArquivo: string;
  filepath: string;
}

@Controller({ fragment: FragmentNames.MENSAGENS })
class MensagensController extends BaseController {

  @OnMount(Aliases.FILTER_CONSULTA_MENSAGENS)
  onFilterMount(event: MountEvent): void {
    FilterService.restoreFilterState(event);
  }

  @OnUnmount(Aliases.FILTER_CONSULTA_MENSAGENS)
  onUnmountFilter(event: MountEvent): void {
    FilterService.persistFilterState(event);
  }

  @OnMount(Aliases.FETCH_MENSAGENS)
  onMountFetchMensagens(event: MountEvent): void {
    const api = event.target as FetchAPI;
    const { nrSeqBeneficiario } = this.historyService.getCurrentRouteParams();
    api.setParameters({ nrSeqBeneficiario });
    api.forceFetch();
  }

  @OnMount(Aliases.HPMS_CUSTOM_CARD_MENSAGENS)
  onMountHpmsCustomCardMessages(event: MountEvent): void {
    const api = event.target as HpmsCustomCardAPI;
    const data = api.state;
    const { ieLeitura } = data as unknown as Mensagem;
    if (ieLeitura !== StatusMensagem.YES) {
      api.setBackground('hsl(var(--color-5))');
    }
  }

  @OnDynamicContentRender(Aliases.HPMS_DYNAMIC_CONTENT_FIELD_STATUS)
  onDynamicContentRenderHpmsMessageCard(event: RenderEvent): void {
    const { data, render } = event;
    const { ieImportante, ieAnexo } = data as Mensagem;
    const elements: ReactElement[] = [];

    if (ieAnexo === StatusMensagem.YES) {
      elements.push(<Image alt="" src="/static/assets/DLS_Attachment_32.svg" className="icon-attachment" />);
    }

    if (ieImportante === StatusMensagem.YES) {
      elements.push(<Stamp icon={StampIcon.WARNING} color={Color.SAFETY_ORANGE} label={''} />);
    }

    render(() => <div className="dynamic-content">
      {...elements}
    </div>);
  }

  @OnDynamicContentRender(Aliases.HPMS_CUSTOM_CARD_MENSAGENS)
  onDynamicContentRenderMessages(event: RenderEvent): void {
    const { data, render } = event;
    const { ieLeitura } = data as Mensagem;
    let TokenLeituraNaoLida: ReactElement = <></>;
    if (ieLeitura !== StatusMensagem.YES) {
      TokenLeituraNaoLida =
        <div className="u-token-bullet">
          <Token type={Type.NOTICE} value={''} />
        </div>;
    }
    render(() => <>
      {TokenLeituraNaoLida}
    </>);
  }

  @OnSelectItem(Aliases.DECK_MENSAGENS)
  onSelectItemDeckMessages(event: SelectItemEvent<DeckValue>): void {
    const { nrSeqBeneficiario } = this.historyService.getCurrentRouteParams();
    const { item, target } = event;
    const api = target as DeckAPI;
    api.unselectAll();
    const { nrSequencia: nrSeqComunicado, ieLeitura } = item as unknown as Mensagem;
    if (ieLeitura != StatusMensagem.YES) {
      HttpService.post(Endpoints.POST.CONFIRMAR_LEITURA_MENSAGEM, { nrSeqBeneficiario, nrSeqComunicado }, {  })
        .catch((response) => ToastService.open(response));
      const mensagensNaoLidas = this.context.get('mensagensNaoLidas') as Function;
      if (mensagensNaoLidas) {
        mensagensNaoLidas(nrSeqBeneficiario);
      }
    }
    this.historyService.push(Routes.DETALHES_MENSAGEM, { nrSeqComunicado });
  }
}

export {
  Anexo,
  MensagensController,
  Mensagem,
  StatusMensagem,
};
